import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { get } from '../../Common/api'
import { useLocation } from 'react-router'
import PublicContext from '../PublicContext'
import MobileBoxListPage from './Mobile/MobileBoxListPage'
import ComputerBoxListPage from './Computer/ComputerBoxListPage'
import TabletBoxListPage from './Tablet/TabletBoxListPage'
import { screenSize } from '../../Common/Common'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'

export default function BoxListPage () {
  const { t } = useTranslation()
  const location = useLocation()
  const { loading, setLoading, setData, data } = useContext(PublicContext)
  const [boxes, setBoxes] = useState([])
  const [nearestBoxes, setNearestBoxes] = useState([])
  const [currentBox, setCurrentBox] = useState()
  const params = new URLSearchParams(location.search)
  const [tabActive, setTabActive] = useState('list')
  const screens = useBreakpoint()

  const lat = params.get('lat')
  const long = params.get('long')

  const getBoxes = () => {
    setLoading(true)
    get({
      url: 'public/boxes',
      params: { lat: lat || '', long: long || '' },
      onSuccess: (json) => {
        setBoxes(json.boxes)
        setNearestBoxes(json.nearest_boxes)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const getBoxesPreload = (ids) => {
    get({
      url: 'public/boxes',
      params: { ids },
      onSuccess: (json) => {
        if (data?.boxes) {
          const boxesToSave = [...data.boxes]
          json.forEach((box) => {
            if (data.boxes.find((b) => b.id === box.id)) {
              const index = data.boxes.findIndex((b) => b.id === box.id)
              boxesToSave[index] = box
            } else {
              boxesToSave.push(box)
            }
          })
          setData({ ...data, boxes: [...boxesToSave] })
        } else {
          setData({ ...data, boxes: json })
        }
      }
    })
  }

  useEffect(() => {
    getBoxes()
  }, [])

  useEffect(() => {
    if (nearestBoxes.length >= 1) {
      getBoxesPreload(nearestBoxes.map((box) => box.id))
    }
  }, [nearestBoxes])

  const textList = nearestBoxes.length > 0 ? t('Public.BoxList.selectBox') : t('Public.BoxList.noBox')

  const boxLists = {
    Mobile: MobileBoxListPage,
    Computer: screens.xl ? ComputerBoxListPage : TabletBoxListPage,
    Tablet: TabletBoxListPage
  }

  const ResponsiveList = boxLists[screenSize()]

  return (
    <ResponsiveList boxes={boxes} nearestBoxes={nearestBoxes} currentBox={currentBox}
      setCurrentBox={setCurrentBox} lat={lat} long={long} textList={textList} loading={loading}
      tabActive={tabActive} setTabActive={setTabActive} />
  )
}
